/* eslint-disable unicorn/numeric-separators-style */
import { StoryData } from '@cinch-nx/data-storyblok'
import { AutotraderStory } from '../storyblok'

export const autotraderFallbackStory: StoryData<AutotraderStory> = {
  name: 'Autotrader',
  created_at: '2025-08-06T09:31:12.880Z',
  published_at: '2025-08-27T09:19:16.071Z',
  id: 76935466813844,
  uuid: 'db3c6759-c7ff-41ac-9261-e857dd6d405b',
  content: {
    SEO: [
      {
        _uid: 'b2d1910d-1597-4321-b555-8ef30173b775',
        HowTo: [],
        title: 'Test Autotrader Title',
        robots: [],
        component: 'SEO',
        openGraph: [],
        description: '',
        twitterCard: [],
        canonicalUrl: '',
        _editable:
          '\u003C!--#storyblok#{"name": "SEO", "space": "143588", "uid": "b2d1910d-1597-4321-b555-8ef30173b775", "id": "76935466813844"}--\u003E',
      },
    ],
    _uid: '8f02e61d-0b9d-47c1-b699-fec43a95a47a',
    body: [
      {
        _uid: 'b4b1a6b7-3e2c-48a0-9398-4fa4c8bb693a',
        text: {
          type: 'doc',
          content: [
            {
              type: 'heading',
              attrs: {
                level: 2,
              },
              content: [
                {
                  text: 'About cinch',
                  type: 'text',
                },
              ],
            },
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Copy here about how our stores are different.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        component: 'RichText',
        _editable:
          '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "b4b1a6b7-3e2c-48a0-9398-4fa4c8bb693a", "id": "76935466813844"}--\u003E',
      },
      {
        _uid: '201bf75e-9bea-4ba4-b577-343a7c3299d6',
        title: 'Latest Cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '15000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        showOnlyCinchStock: true,
        showOnlyRecentlyViewedVehicles: false,
        _editable:
          '\u003C!--#storyblok#{"name": "CarsCarousel", "space": "143588", "uid": "201bf75e-9bea-4ba4-b577-343a7c3299d6", "id": "76935466813844"}--\u003E',
      },
      {
        _uid: '5c2b42e3-2db2-410c-b07b-00fca53bba5c',
        rows: [
          {
            _uid: 'eef41e78-fcbc-4186-b3d2-f18bf7e27b4f',
            columns: [
              {
                _uid: 'a88d9f86-87bd-42c6-9ec4-50958e696dc8',
                text: {
                  type: 'doc',
                  content: [
                    {
                      type: 'heading',
                      attrs: {
                        level: 2,
                      },
                      content: [
                        {
                          text: 'More About Autotrader',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Copy here about how you find a car to reserve and test drive.',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          type: 'hard_break',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          type: 'hard_break',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                component: 'RichText',
                _editable:
                  '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "a88d9f86-87bd-42c6-9ec4-50958e696dc8", "id": "76935466813844"}--\u003E',
              },
              {
                alt: 'honda civic',
                _uid: '034fb0a2-1e43-492a-a8c2-e8abdaaa0893',
                fill: true,
                image: {
                  id: 79102611804264,
                  alt: 'Front view of a grey Honda Civic parked on a dirt road, with a cloudy sky in the background. License plate reads "E2 HUK."',
                  name: '',
                  focus: '',
                  title: 'Honda Civic exterior',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/1996x1330/dbcd5ea068/honda-civic-2017-exterior2.jpg',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Front view of a grey Honda Civic parked on a dirt road, with a cloudy sky in the background. License plate reads "E2 HUK."',
                    title: 'Honda Civic exterior',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                height: '374px',
                quality: '',
                priority: false,
                component: 'NextImage',
                objectFit: 'cover',
                objectCover: 'left',
                borderRadius: '22px',
                _editable:
                  '\u003C!--#storyblok#{"name": "NextImage", "space": "143588", "uid": "034fb0a2-1e43-492a-a8c2-e8abdaaa0893", "id": "76935466813844"}--\u003E',
              },
            ],
            component: 'Columns_2',
            reverseColumnOrderForMobile: true,
            _editable:
              '\u003C!--#storyblok#{"name": "Columns_2", "space": "143588", "uid": "eef41e78-fcbc-4186-b3d2-f18bf7e27b4f", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: 'a9cbb9b9-80a1-4bd4-9ee3-b4de8895e75f',
            columns: [
              {
                alt: 'car on driveway',
                _uid: 'f23082fd-2912-40a9-a75a-5bf064cca092',
                fill: true,
                image: {
                  id: 5102867,
                  alt: '',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/783x440/a96c06081d/d4b179d5-391f-4ace-bcc8-c03c95fcc2ad_electric-car-charging-adobestock.jpg',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {},
                  is_external_url: false,
                },
                height: '374px',
                quality: '100',
                priority: false,
                component: 'NextImage',
                objectFit: 'cover',
                objectCover: 'center',
                borderRadius: '22px',
                _editable:
                  '\u003C!--#storyblok#{"name": "NextImage", "space": "143588", "uid": "f23082fd-2912-40a9-a75a-5bf064cca092", "id": "76935466813844"}--\u003E',
              },
              {
                _uid: '99c179a4-2169-49ab-8562-ee317e124dd0',
                text: {
                  type: 'doc',
                  content: [
                    {
                      type: 'heading',
                      attrs: {
                        level: 2,
                      },
                      content: [
                        {
                          text: 'History of Autotrader',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      content: [
                        {
                          text: 'Copy here about how you find a car to reserve and test drive.',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          type: 'hard_break',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          type: 'hard_break',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                        {
                          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                color: '',
                              },
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                component: 'RichText',
                _editable:
                  '\u003C!--#storyblok#{"name": "RichText", "space": "143588", "uid": "99c179a4-2169-49ab-8562-ee317e124dd0", "id": "76935466813844"}--\u003E',
              },
            ],
            component: 'Columns_2',
            _editable:
              '\u003C!--#storyblok#{"name": "Columns_2", "space": "143588", "uid": "a9cbb9b9-80a1-4bd4-9ee3-b4de8895e75f", "id": "76935466813844"}--\u003E',
          },
        ],
        component: 'GridRows',
        _editable:
          '\u003C!--#storyblok#{"name": "GridRows", "space": "143588", "uid": "5c2b42e3-2db2-410c-b07b-00fca53bba5c", "id": "76935466813844"}--\u003E',
      },
      {
        _uid: '943bcd41-2e61-40ac-b067-15dc29fe443d',
        title: 'Why choose cinch on Autotrader?',
        content: [
          {
            _uid: '1b2fb3a2-dc88-46f0-b4c3-9adc278d19d1',
            rows: [
              {
                _uid: '63f4f5f6-251e-40a9-bdbe-82397ede7996',
                columns: [
                  {
                    _uid: 'fb7d0caf-e4b3-448d-88a9-f478d310f836',
                    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    icon: 'shield',
                    title: 'Range of cars',
                    component: 'FeatureCard',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCard", "space": "143588", "uid": "fb7d0caf-e4b3-448d-88a9-f478d310f836", "id": "76935466813844"}--\u003E',
                  },
                  {
                    _uid: '1449f92f-919d-4af1-a878-a5529db9f647',
                    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    icon: 'heart-outline',
                    title: '90-day MBG',
                    component: 'FeatureCard',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCard", "space": "143588", "uid": "1449f92f-919d-4af1-a878-a5529db9f647", "id": "76935466813844"}--\u003E',
                  },
                  {
                    _uid: '794af5c5-80fb-4b7b-939d-7f2140ecbd39',
                    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    icon: 'shield',
                    title: 'Flexible payment options',
                    component: 'FeatureCard',
                    _editable:
                      '\u003C!--#storyblok#{"name": "FeatureCard", "space": "143588", "uid": "794af5c5-80fb-4b7b-939d-7f2140ecbd39", "id": "76935466813844"}--\u003E',
                  },
                ],
                component: 'GenericGridRow',
                _editable:
                  '\u003C!--#storyblok#{"name": "GenericGridRow", "space": "143588", "uid": "63f4f5f6-251e-40a9-bdbe-82397ede7996", "id": "76935466813844"}--\u003E',
              },
            ],
            component: 'GenericGrid',
            _editable:
              '\u003C!--#storyblok#{"name": "GenericGrid", "space": "143588", "uid": "1b2fb3a2-dc88-46f0-b4c3-9adc278d19d1", "id": "76935466813844"}--\u003E',
          },
        ],
        component: 'WhyChooseSection',
        _editable:
          '\u003C!--#storyblok#{"name": "WhyChooseSection", "space": "143588", "uid": "943bcd41-2e61-40ac-b067-15dc29fe443d", "id": "76935466813844"}--\u003E',
      },
      {
        _uid: '0c38a0fb-114d-46ec-98d0-e329aecb5f57',
        faqs: [
          {
            _uid: '160dc47d-9a9f-4a52-8cd4-01c0e794a3ed',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'Can I part-ex my old car?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "160dc47d-9a9f-4a52-8cd4-01c0e794a3ed", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: '67e594cb-59e7-4e04-80b8-8a4532325b69',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'Will I be able to buy a car on finance?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "67e594cb-59e7-4e04-80b8-8a4532325b69", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: 'b36f0716-58d6-4821-a84a-821de5d1b004',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'What do I need to bring with me on the day?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "b36f0716-58d6-4821-a84a-821de5d1b004", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: 'cc1a9709-57d7-4b79-97f5-23abc004a6ce',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title:
              'If I don’t like the car I’ve chosen can I test drive a different one?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "cc1a9709-57d7-4b79-97f5-23abc004a6ce", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: '39d26654-b272-4a11-b335-703fc78b4dda',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'Can I drive my new car away on the same day?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "39d26654-b272-4a11-b335-703fc78b4dda", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: '053103b8-2100-4319-97d9-aceb19640132',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title:
              'Do I need to make an appointment or can I walk in on the day?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "053103b8-2100-4319-97d9-aceb19640132", "id": "76935466813844"}--\u003E',
          },
          {
            _uid: '2695805b-1d3a-430a-966d-a431e689b9c9',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: '123',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            title: 'What is covered in the 14-day money back guarantee?',
            component: 'AccordionItem',
            _editable:
              '\u003C!--#storyblok#{"name": "AccordionItem", "space": "143588", "uid": "2695805b-1d3a-430a-966d-a431e689b9c9", "id": "76935466813844"}--\u003E',
          },
        ],
        title: 'Frequently asked questions',
        component: 'FaqSection',
        _editable:
          '\u003C!--#storyblok#{"name": "FaqSection", "space": "143588", "uid": "0c38a0fb-114d-46ec-98d0-e329aecb5f57", "id": "76935466813844"}--\u003E',
      },
    ],
    hero: [
      {
        _uid: 'e174c1c2-f1dd-4b6b-9641-ead3fe14739d',
        body: "We've partnered with Autotrader, giving UK drivers a great selection of used cars to browse and buy online.",
        image: {
          id: 78789995341890,
          alt: 'Cinch store hero image',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/900x600/69de4df962/cinch-store-hero-image.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Cinch store hero image',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        title: 'Autotrader and cinch',
        component: 'GenericHero',
        _editable:
          '\u003C!--#storyblok#{"name": "GenericHero", "space": "143588", "uid": "e174c1c2-f1dd-4b6b-9641-ead3fe14739d", "id": "76935466813844"}--\u003E',
      },
    ],
    component: 'AutotraderPage',
    _editable:
      '\u003C!--#storyblok#{"name": "AutotraderPage", "space": "143588", "uid": "8f02e61d-0b9d-47c1-b699-fec43a95a47a", "id": "76935466813844"}--\u003E',
  },
  alternates: [],
  full_slug: '',
  group_id: '',
  is_startpage: false,
  meta_data: null,
  parent_id: 0,
  position: 0,
  first_published_at: null,
  slug: '',
  lang: '',
  sort_by_date: null,
  tag_list: [],
}
